import { OBaseModel } from '@olameter/o-utilities';
import { ContractPicker } from 'src/app/proto/generated/inv_api_message_pb';

export class ContractModel implements OBaseModel {
  name: string;
  contractName: string;

  static MapperList(source: ContractPicker[]): ContractModel[] {
    const list: ContractModel[] = [];
    source?.forEach((element) => {
      list.push(ContractModel.Mapper(element));
    });
    return list;
  }

  static Mapper(source: ContractPicker): ContractModel {
    const destination: ContractModel = new ContractModel();
    if (source != null) {
      destination.name = source.getName();
      destination.contractName = source.getContractName();
    }

    return destination;
  }
}
